export function useScrollToElement() {
    function scrollToAnchor(anchor: string, offset = 0): void {
        const domElement = document.querySelector<HTMLElement>(anchor);
        if (domElement) {
            if (offset === 0) {
                domElement.scrollIntoView({behavior: 'smooth', block: 'start'});
            } else {
                const coordWithOffset = domElement.getBoundingClientRect().top + window.scrollY - offset;
                window.scrollTo({
                    top: coordWithOffset,
                    behavior: 'smooth',
                });
            }
        }
    }

    return {
        scrollToAnchor,
    };
}
